import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, InfoWindow, useLoadScript } from '@react-google-maps/api';
import { Typography, Button, Checkbox, Fab, Select, MenuItem, IconButton, DialogContent, Dialog, Modal, Switch, InputLabel, FormControl, TextField, Paper } from "@mui/material";
import OpaqueLoading from '../../components/opaqueLoading/opaqueLoading';

const containerStyle = {
  width: '100%',
  height: '1000px',
  maxHeight: '1000px',
  overflow: 'hidden'
};

const authorLogs = [
  { id: 1, lat: 28.6139, lng: 77.2090, label: "Log 1" },
  { id: 2, lat: 28.7041, lng: 77.1025, label: "Log 2" },
  { id: 3, lat: 28.5355, lng: 77.3910, label: "Log 3" }
];

const LiveAudit = () => {
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user);
  const [hoveredAuditor, setHoveredAuditor] = useState(null);
  const [auditorLocations, setAuditorLocations] = useState([])
  const [infoWindowHovered, setInfoWindowHovered] = useState(false);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mapCenter, setMapCenter] = useState({ lat: 28.6139, lng: 77.2090 });



  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyCMIjqkbWwEUD4GCRv9HhfD8cpTQ4DWbvQ'
    // googleMapsApiKey: 'AIzaSyBmaS0B0qwokES4a_CiFNVkVJGkimXkNsk'
  });

  useEffect(() => {
    getLatLong();
  }, [rsm, asm, rm]);


  useEffect(() => {
    getLatLong()
    // getClusterInPicklist()
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])


  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      // setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      // setLoading(false);
    }
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }
  }

  const getLatLong = async () => {
    try {
      setLoading(true);
      const payload = {
        ownerId: rm,
        asm: asm,
        rsm: rsm
      }
      const response = await window.Platform.database.getLatLong(payload);
      // if (response?.status) {
      //   console.error("Failed to load auditor data", response);
      //   setLoading(false);
      // } else {
      //   console.log("Loaded auditorLocations:", response.data);
      //   setAuditorLocations(response.data);
      //   setLoading(false);

      // }
      if (response?.status) {
        console.log("Failed to load auditor data", response);
        setLoading(false);
      } else {
        console.log("Loaded auditorLocations:", response.data);
        setAuditorLocations(response.data);
        if (response.data.length > 0) {
          const first = response.data[0];
          setMapCenter({
            lat: Number(first.current_lat),
            lng: Number(first.current_long)
          });
        }
        setLoading(false);
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  };

  if (!isLoaded) return <div>Loading Map...</div>;

  const center = auditorLocations.length > 0
    ? { lat: Number(auditorLocations[0].current_lat), lng: Number(auditorLocations[0].current_long) }
    : { lat: 28.6139, lng: 77.2090 };

  return (
    <>
      {loading && <OpaqueLoading />}

      <div className='mt-2'>
        <Paper elevation={3}
          sx={{
            p: 2,
            mb: 2,
            width: '100%',        // takes full width of parent
            // maxWidth: '1000px',   // optional: control max width
            mx: 'auto',
            backgroundColor: "#ebf0fa"          // center it horizontally
          }}>
          <div className="row">
            {userData?.role.includes('admin') && <div className="col-md-3">
              <FormControl fullWidth size="small">
                <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                  <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                  {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                </Select>
              </FormControl>
            </div>}
            {userData?.role != 'asm' && <div className="col-md-3">
              <FormControl fullWidth size="small">
                <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: '500' }}>
                  <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                  {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                </Select>
              </FormControl>
            </div>}
            <div className="col-md-3">
              <FormControl fullWidth size="small">
                <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM</InputLabel>
                <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                  <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                  {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                </Select>
              </FormControl>
            </div>

          </div>
        </Paper>
        <div className="mt-2" style={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
          {(() => {
            // Use visitCount from API response for each RM, filter by selected RM if set
            let totalVisitCount = 0;
            let rmSet = new Set();
            auditorLocations.forEach(auditor => {
              if (rm && auditor.id !== rm) return;
              totalVisitCount += Number(auditor.visitCount) || 0;
              if (auditor.name) rmSet.add(auditor.name);
            });
            const totalRms = rmSet.size;
            return `👤 Unique RMs: ${totalRms}   |   📍 Total Visit Count: ${totalVisitCount}`;
          })()}
        </div>

        <div className='row mb-3 mt-3'>
          <div className='col-md-10' style={{ height: '10000px', maxHeight: '1000px', overflow: 'hidden' }}>
            <GoogleMap
              zoom={6}
              mapContainerStyle={containerStyle}
              center={mapCenter}
              options={{
                disableDefaultUI: false,
                zoomControl: true,
                streetViewControl: false,
              }}
            >
              {auditorLocations?.filter(auditor =>
                auditor.current_lat &&
                auditor.current_long &&
                !isNaN(Number(auditor.current_lat)) &&
                !isNaN(Number(auditor.current_long))
              ).map((auditor, ind) => (
                <Marker
                  key={ind}
                  position={{ lat: Number(auditor.current_lat), lng: Number(auditor.current_long) }}
                  onMouseOver={() => setHoveredAuditor(auditor)}
                  onMouseOut={() => {
                    setTimeout(() => {
                      if (!infoWindowHovered) setHoveredAuditor(null);
                    }, 200);
                  }}
                />
              ))}

              {hoveredAuditor && hoveredAuditor.current_lat && hoveredAuditor.current_long && !isNaN(Number(hoveredAuditor.current_lat)) && !isNaN(Number(hoveredAuditor.current_long)) && (
                <InfoWindow
                  position={{ lat: Number(hoveredAuditor.current_lat), lng: Number(hoveredAuditor.current_long) }}
                  onCloseClick={() => setHoveredAuditor(null)}
                  options={{ disableAutoPan: true }}
                >
                  <div
                    onMouseEnter={() => setInfoWindowHovered(true)}
                    onMouseLeave={() => {
                      setInfoWindowHovered(false);
                      setTimeout(() => {
                        if (!infoWindowHovered) setHoveredAuditor(null);
                      }, 200);
                    }}
                    // style={{ minWidth: '300px', minHeight: '120px' }}
                    style={{
                      height: "190px",
                      zIndex: '1000',
                      width: (
                        (hoveredAuditor?.userCurrentAddress && hoveredAuditor?.userCurrentAddress?.length > 40)) ? "350px" : "300px"
                    }}
                  >
                    <div>
                      <b style={{ fontWeight: "500", color: "black", fontSize: "12px" }}>RM Name:</b>
                      <span style={{ fontWeight: "400", marginLeft: "10px", color: "black", fontSize: "11px" }}>
                        {hoveredAuditor.name}
                      </span>
                    </div>

                    <div className="mt-2">
                      <b style={{ fontWeight: "500", color: "black", fontSize: "12px" }}>Email:</b>
                      <span style={{ fontWeight: "400", marginLeft: "10px", color: "black", fontSize: "11px" }}>
                        {hoveredAuditor.email}
                      </span>
                    </div>
                    <div className="mt-2">
                      <b style={{ fontWeight: "500", color: "black", fontSize: "12px" }}>Mobile Number:</b>
                      <span style={{ fontWeight: "400", marginLeft: "10px", color: "black", fontSize: "11px" }}>
                        {hoveredAuditor.mobno}
                      </span>
                    </div>
                    <div className="mt-2">
                      <b style={{ fontWeight: "500", color: "black", fontSize: "12px" }}>Area Name:</b>
                      <span style={{ fontWeight: "400", marginLeft: "10px", color: "black", fontSize: "11px" }}>
                        {hoveredAuditor.clusterName}
                      </span>
                    </div>
                    <div className="mt-2">
                      <b style={{ fontWeight: "500", color: "black", fontSize: "12px" }}>Reporting Manager Name:</b>
                      <span style={{ fontWeight: "400", marginLeft: "10px", color: "black", fontSize: "11px" }}>
                        {hoveredAuditor.reportingManagerName}
                      </span>
                    </div>

                    <div className="mt-2">
                      <b style={{ fontWeight: "500", color: "black", fontSize: "12px" }}>Address :</b>
                      <span style={{ fontWeight: "400", marginLeft: "10px", color: "black", fontSize: "11px" }}>
                        {hoveredAuditor.userCurrentAddress}
                      </span>
                    </div>
                    <div className="mt-2">
                      <b style={{ fontWeight: "500", color: "black", fontSize: "12px" }}>Date & Time :</b>
                      <span style={{ fontWeight: "400", marginLeft: "10px", color: "black", fontSize: "11px" }}>
                        {(() => {
                          const raw = hoveredAuditor.updateLatLongTime;
                          if (!raw) return '';
                          const d = new Date(raw);
                          if (isNaN(d.getTime())) return raw;
                          const pad = n => n.toString().padStart(2, '0');
                          const date = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
                          let hours = d.getHours();
                          const ampm = hours >= 12 ? 'PM' : 'AM';
                          hours = hours % 12;
                          hours = hours ? hours : 12; // 0 should be 12
                          const time = `${pad(hours)}:${pad(d.getMinutes())}:${pad(d.getSeconds())} ${ampm}`;
                          return `${date} ${time}`;
                        })()}
                      </span>
                    </div>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          </div>
          <div className='col-md-2'>
            <div style={{ maxHeight: '1000px', overflowY: 'auto', border: '1px solid #000', borderRadius: '4px' }}>

              <table className="table table-bordered table-sm mb-0 p-0" style={{ tableLayout: "auto", whiteSpace: "nowrap", color: "black", border: "1px solid #000" }}>
                <thead>
                  <tr>
                    <th className="text-dark bg-white text-center" style={{ border: "1px solid #000", fontSize: "10px", padding: 0, margin: 0, width: '1%' }}>#</th>
                    <th className="text-dark bg-white text-center" style={{ border: "1px solid #000", fontSize: "8px", padding: 0, margin: 0, width: '1%', whiteSpace: 'nowrap' }}>RM Name</th>
                    <th className="text-dark bg-white text-center" style={{ border: "1px solid #000", fontSize: "8px", padding: 0, margin: 0, width: '1%' }}>Visit Count</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    // Use visitCount from API response for each RM, filter by selected RM if set
                    const rmMap = {};
                    auditorLocations.forEach(auditor => {
                      const name = auditor.name || "N/A";
                      // If RM filter is set, only include matching RM
                      if (rm && auditor.id !== rm) return;
                      if (!rmMap[name]) {
                        rmMap[name] = {
                          visitCount: Number(auditor.visitCount) || 0
                        };
                      } else {
                        rmMap[name].visitCount += Number(auditor.visitCount) || 0;
                      }
                    });
                    const entries = Object.entries(rmMap);
                    if (entries.length === 0) {
                      return (
                        <tr>
                          <td className="text-center" colSpan={3} style={{ border: "1px solid #000", padding: 0, margin: 0 }}>No Data</td>
                        </tr>
                      );
                    }
                    return entries.map(([name, data], idx) => (
                      <tr key={idx} style={{ fontWeight: "500", color: "black", fontSize: "8px" }}>
                        <td className="text-dark bg-white text-center" style={{ fontWeight: "500", color: "black", fontSize: "8px", border: "1px solid #000", padding: 0, margin: 0, width: '1%' }}>{idx + 1}</td>
                        <td className="text-dark bg-white text-center" style={{ fontWeight: "500", color: "black", fontSize: "8px", border: "1px solid #000", padding: 0, margin: 0, width: '1%', whiteSpace: 'nowrap' }}>{name?.toUpperCase()}</td>
                        <td className="bg-white text-center" style={{ fontWeight: "500", color: "green", fontSize: "8px", border: "1px solid #000", padding: 0, margin: 0, width: '1%' }}>{data.visitCount}</td>
                      </tr>
                    ));
                  })()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default LiveAudit;
